import { render, staticRenderFns } from "./SSGetMore.vue?vue&type=template&id=0d092a08&scoped=true&"
import script from "./SSGetMore.vue?vue&type=script&lang=js&"
export * from "./SSGetMore.vue?vue&type=script&lang=js&"
import style0 from "./SSGetMore.vue?vue&type=style&index=0&id=0d092a08&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d092a08",
  null
  
)

export default component.exports